import { offlinePriceTablesRepository } from '../../../modules/offline/repositories/offlinePriceTables.repository';
import { UseFindProductGridProps } from './product-grid.types';

export const getParamsWithPriceTable = async (
  params: UseFindProductGridProps,
): Promise<UseFindProductGridProps> => {
  const mustUseDefaultPriceTable =
    params.isOfflineMode &&
    !params.orderId &&
    !params.priceTableId &&
    params.useDefaultPriceTableWhenOffline;

  if (mustUseDefaultPriceTable) {
    const defaultPriceTable = await offlinePriceTablesRepository.getDefaultOrFail();
    return {
      ...params,
      priceTableId: defaultPriceTable.id,
    };
  }

  return params;
};
